var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHapvidaMiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1078_2882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 19.2354C23.0126 19.2354 22.1378 21.1769 21.851 21.8148C21.2726 23.0976 20.7702 24.8625 21.6608 25.9887C21.9365 26.3033 22.2908 26.5582 22.6964 26.7335C23.1021 26.9088 23.5482 27.0001 24.0003 27.0001C24.4525 27.0001 24.8986 26.9088 25.3042 26.7335C25.7099 26.5582 26.0642 26.3033 26.3399 25.9887C27.229 24.8604 26.7266 23.0955 26.1497 21.8148C25.8613 21.1769 24.9857 19.2354 24 19.2354",
    fill: "#FCB812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 3.00811C23.4288 2.96711 22.857 3.082 22.3433 3.34101C21.8295 3.60002 21.3922 3.99388 21.0761 4.48234C20.4619 5.38721 20.0046 7.17413 21.3094 10.5453C21.6686 11.4723 22.7596 14.2941 24.0002 14.2941C25.2407 14.2941 26.3317 11.473 26.6909 10.5453C27.9957 7.17413 27.5378 5.38721 26.9256 4.48234C26.6091 3.99387 26.1716 3.60003 25.6576 3.34103C25.1437 3.08203 24.5717 2.96715 24.0002 3.00811Z",
    fill: "#F0402E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5238 17.87H19.4931C18.1705 17.9545 16.456 18.2825 15.7996 19.366C15.6269 19.6879 15.5345 20.043 15.5295 20.404C15.5245 20.765 15.6071 21.1223 15.7709 21.4483C15.9347 21.7743 16.1752 22.0603 16.4741 22.2843C16.7729 22.5082 17.1221 22.6642 17.4946 22.7401C18.7902 22.9382 20.145 21.8881 21.0479 20.965C21.5043 20.5021 22.8883 19.0934 22.5294 18.3784C22.1869 17.6946 20.3211 17.8139 19.5238 17.8643",
    fill: "#F5821E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5071 17.8652H28.4764C28.2111 17.8481 27.8275 17.8232 27.4222 17.8232C26.607 17.8232 25.6989 17.9227 25.4703 18.378C25.1114 19.0932 26.4968 20.503 26.9516 20.9654C27.8552 21.8852 29.2054 22.9349 30.5054 22.741C30.8778 22.6651 31.2269 22.5091 31.5258 22.2851C31.8246 22.061 32.0651 21.7749 32.2289 21.4488C32.3926 21.1227 32.4752 20.7653 32.4702 20.4042C32.4653 20.0431 32.3728 19.6878 32.2001 19.3659C31.5438 18.2821 29.8295 17.9539 28.5071 17.8694",
    fill: "#F5821E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1862 9.35255C15.0078 9.35213 14.8298 9.37014 14.6546 9.40637C14.137 9.54256 13.6553 9.80569 13.2467 10.1754C12.838 10.5452 12.5134 11.0117 12.2977 11.5388C12.082 12.066 11.9812 12.6398 12.0029 13.2159C12.0246 13.7919 12.1683 14.3549 12.423 14.8613C12.9525 15.7993 14.284 16.9488 17.6236 17.0929C18.5419 17.133 21.3359 17.2559 21.8094 16.0988C22.2829 14.9417 20.321 12.7852 19.6766 12.0747C17.707 9.90835 16.2067 9.35255 15.1862 9.35255Z",
    fill: "#F05921"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3447 9.40636C33.1695 9.37062 32.9915 9.35261 32.8131 9.35254C31.7925 9.35254 30.2915 9.90836 28.3239 12.0763C27.6795 12.7852 25.7176 14.944 26.1904 16.0996C26.6632 17.2552 29.4594 17.1339 30.3762 17.0922C33.7159 16.9481 35.0482 15.8031 35.5771 14.8606C35.8317 14.3542 35.9754 13.7912 35.9971 13.2151C36.0189 12.6391 35.918 12.0653 35.7023 11.5381C35.4867 11.0109 35.162 10.5444 34.7533 10.1747C34.3447 9.80493 33.8629 9.54182 33.3454 9.40562",
    fill: "#F05921"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1078_2882",
    x: 0.952381,
    y: 0.238095,
    width: 46.0952,
    height: 46.0952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.28571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.52381
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.960784 0 0 0 0 0.509804 0 0 0 0 0.117647 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1078_2882"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1078_2882",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHapvidaMiniLogo);
export default __webpack_public_path__ + "static/media/hapvida-mini-logo.71316c7de06a46d07d8a4c8ab83e8164.svg";
export { ForwardRef as ReactComponent };